.mini-basket-container {
  &.open::after {
    content: ' ';
    display: block;
    width: 20px;
    position: absolute;

    height: 40px;

    @include breakpointMin('sm') {
      width: 100px;
    }
    @include breakpointMin('md') {
      height: 60px;
    }
    @media (min-width: 1280px) {
      height: 80px;
    }
  }

  .desktop-basket {
    display: none;
  }
  .mobile-basket {
    display: block;
  }

  .basket-content {
    display: none;
  }

  @include breakpointMin('sm') {
    .desktop-basket {
      display: block;
    }
    .mobile-basket {
      display: none;
    }

    .basket-content {
      display: block;
    }
  }

  .mini-basket {
    border-radius: 3px;
    box-shadow: 0 0 4px 1px rgb(0 0 0 / 20%);
    width: 400px;
    padding: 10px;
    position: absolute;
    background: white;
    left: auto;
    right: 15px;
    top: 40px;
    @include layerIndex('modal');
    @include breakpointMin('md') {
      top: 60px;
    }
    @media (min-width: 1280px) {
      right: 50px;
      top: 80px;
    }
    @media (min-width: 1600px) {
      right: 100px;
    }
    &-calculation {
      text-align: right;
      margin-bottom: 16px;
      &-row {
        display: flex;
        justify-content: space-between;
        font-family: var(--primary-font);
        color: var(--color-nero);
        font-size: 14px;
        line-height: 18px;
        &:first-child {
          span {
            &:last-child {
              font-weight: var(--font-weight-semibold);
            }
          }
        }
      }
    }
    &-product {
      display: flex;
      column-gap: 5px;
      justify-content: space-between;
      &:last-child {
        margin-bottom: 0;
      }
      &:not(:only-child) {
        .mini-basket-product-name {
          width: 30%;
        }
      }
      &:not(.mini-basket-product-new) {
        padding: 4px 0;
        border-top: 1px solid var(--color-silver);
        .mini-basket-product-name {
          display: flex;
          .mini-basket-product-name-par {
            align-self: center;
          }
        }
        &:last-child {
          padding-bottom: 0;
        }
      }
      &-image {
        width: 50px;
        height: 44px;
        align-self: center;

        img {
          width: 100%;
          max-width: 100%;
          height: auto;
        }
      }
      &-name {
        align-self: center;
        text-decoration: none;
        overflow: hidden;
        margin: 0;
        font-weight: var(--font-weight-regular);
        max-height: 2.5em; //exact number of lines
        &:hover {
          text-decoration: underline;
        }
        &-par {
          margin: 0;
          display: inline-block;
          max-height: 3.75em; //one more line
          position: relative;
          // webkit solution to multi-line text overflow
          @supports (-webkit-line-clamp: 2) {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          &:before {
            // for the ellipsis
            background: var(--color-white);
            background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 50%);
            bottom: 1.25em;
            content: '\02026';
            height: 1.25em;
            position: absolute;
            right: 0;
            text-align: right;
            width: 4em;
          }

          &:after {
            // to cover all but the last line of text
            background: white;
            content: attr(data-name-clamp);
            left: 0;
            height: 1.25em;
            overflow: hidden;
            position: absolute;
            top: 0;
            width: 100%;
            transform: none !important;
          }

          @supports (-webkit-line-clamp: 2) {
            &:before,
            &:after {
              content: none;
            }
          }
        }
      }
      &-price {
        white-space: nowrap;
        align-self: center;
        margin: 0;
        text-align: right;
        width: 60px;
        font-weight: var(--font-weight-semibold);
        &.mini-basket-product-price-discount {
          color: var(--color-livique-cherryade);
        }
        &-total {
          font-size: 24px;
          &-currency {
            font-size: 14px;
          }
        }
        &-total,
        &-total-currency {
          font-family: var(--primary-font);
        }
      }
      &-name,
      &-price,
      &-count {
        font-family: var(--primary-font);
        font-size: 14px;
        color: var(--color-nero);
      }
      &-new {
        column-gap: 8px;
        .mini-basket-product-image {
          align-self: flex-start;
        }
        .mini-basket-product-name {
          font-size: 14px;
          line-height: 1.5;
          max-height: 3.375em;
          flex-grow: 1;
        }
      }
      lilu-icon {
        cursor: pointer;
      }
    }
    &-empty {
      &-title,
      &-text {
        font-family: var(--primary-font);
        margin: 0;
      }
      &-title {
        font-size: 18px;
        font-weight: var(--font-weight-semibold);
        margin-bottom: 10px;
      }
      &-text {
        font-size: 14px;
        line-height: 1.5;
        a {
          color: var(--color-nero);
          text-decoration: underline;
        }
      }
      &-icon {
        display: inline-block;
      }
      &-texts {
        display: inline-block;
        padding-left: 10px;
      }
    }
    .scrolling-wrapper {
      max-height: 500px;
      overflow: scroll;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }
    .scrolling-wrapper::-webkit-scrollbar {
      display: none;
    }
  }

  &.small-header .mini-basket {
    top: 50px;
    transition: top 0.3s;
  }

  lilu-button {
    margin-bottom: 10px;
  }

  .mini-basket-empty-icon {
    lilu-icon {
      font-size: 55px;
    }
  }

  lilu-icon {
    align-self: center;
  }

  .basket-notification-container {
    display: none;

    .basket-notification-text {
      .basket-notification__image {
        width: 50px;
      }

      .basket-notification__message {
        width: 318px;
      }
    }
  }
}
